import React from 'react'

import Grid from '../../../../components/Grid'
import NavigationBarItem from './NavigationBarItem'
import { useOutsideClick } from '../../../../utils'

import { TNavItem } from '../../../../types/mainNavigation'
import SearchBar from '../SearchBar'

const NavigationBar: React.FC<{ navItems: TNavItem[] }> = (props) => {
  const [currentIndex, setCurrentIndex] = React.useState<number>(-1)
  const navigationRef = React.useRef<HTMLElement>(null)

  useOutsideClick(navigationRef, () => setCurrentIndex(-1))

  return (
    <Grid.Container className="relative" ref={navigationRef}>
      <Grid.Row className="hidden lg:block">
        <Grid.Col>
          <ul className="flex items-center -mb-2 justify-between">
            {props.navItems.map((item, index, arr) => {
              return (
                <React.Fragment key={item.label}>
                  {item.divide && <li className="block border-lightgrey-light h-24 border-l-2" />}
                  <NavigationBarItem
                    {...item}
                    onClick={() => setCurrentIndex(index)}
                    isActive={currentIndex === index}
                    index={index}
                    isFirst={index === 0}
                    isLast={index === arr.length - 1}
                  />
                </React.Fragment>
              )
            })}
          </ul>
        </Grid.Col>
      </Grid.Row>
      <Grid.Row>
        <Grid.Col>
          <SearchBar />
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  )
}

export default NavigationBar
